export const checkErrorResponseStatus = (error: any, expectedStatus: number) =>
  error?.response?.status === expectedStatus
